import React, { useState } from 'react'
import './HomeSliderSecundario.scss'
import { IoIosArrowDropleft, IoIosArrowDropright } from 'react-icons/io'
import { Carousel } from 'react-responsive-carousel'

const infoSliders = {
    title: '¿Eres una empresa o un profesional del sector?',
    subtitle: 'Accede a un presupuesto online',
    slidersInfo: [
        {
            img: '/static/img/img-slider-presupuesto-1.jpg',
            textTitle: 'Busca los productos de tu interés',
            textSubtitle: 'Identifica las categorías y utiliza los filtros para encontrar los productos que buscas.'
        },
        {
            img: '/static/img/img-slider-presupuesto-2.jpg',
            textTitle: 'Escoge tamaño, formato y cantidad',
            textSubtitle: 'Selecciona las propiedades específicas así como las dimensiones de cada producto.'
        },
        {
            img: '/static/img/img-slider-presupuesto-3.jpg',
            textTitle: 'Visualiza el resumen de tu solicitud',
            textSubtitle: 'Revisa tu solicitud. Puedes modificar cantidades de un determinado producto o eliminarlo del listado.'
        },
        {
            img: '/static/img/img-slider-presupuesto-4.jpg',
            textTitle: 'Finaliza tu solicitud',
            textSubtitle: 'Completa el formulario y recibirás un correo electrónico con el presupuesto solicitado.'
        }
    ]
}

export const HomeSliderSecundario = () => {
    const [slideDesktop, setSlideDesktop] = useState(0)

    const handleClickSlidePrev = () => {
        if (slideDesktop > 0) {
            setSlideDesktop(slideDesktop - 1)
        }
    }

    const handleClickSlideNext = () => {
        if (slideDesktop < infoSliders.slidersInfo.length) {
            setSlideDesktop(slideDesktop + 1)
        }
    }
    return (
        <div className="home-slider-secundario">
            <div className="title">
                <p>{infoSliders.title}</p>
            </div>
            <div className="subtitle">
                <p>{infoSliders.subtitle}</p>
            </div>
            <div className="carousel-slide">
                <div className="arrow pointer left-arrow" onClick={handleClickSlidePrev}><IoIosArrowDropleft size={50} /></div>
                <Carousel
                    className="carousel-slide-secundario"
                    selectedItem={slideDesktop}
                    transitionTime='1000'
                    showArrows={false}
                    showStatus={false}
                    showThumbs={false}
                >
                    {infoSliders.slidersInfo.map((slideInfo, index) => {
                        return (
                            <div className="img-info" key={index}>
                                <div className="img">
                                    <img src={slideInfo.img} alt="img slide" />
                                </div>
                                <div className="info">
                                    <p className="title">{slideInfo.textTitle}</p>
                                    <p className="subtitle">{slideInfo.textSubtitle}</p>
                                </div>
                            </div>
                        )
                    })}
                </Carousel>
                <div className="arrow pointer right-arrow" onClick={handleClickSlideNext}><IoIosArrowDropright size={50} /></div>
            </div>
        </div>
    )
}
